import { ReferralsApi } from "@/api/referrals";
import { SetReferralPaymentSettingsRequest } from "@/api/referrals/types";
import { useUIStore } from "@/stores";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useSetReferralPaymentSettings = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate: setReferralPaymentSettings, isPending } = useMutation({
    mutationFn: (body: SetReferralPaymentSettingsRequest) =>
      ReferralsApi.setReferralPaymentSettings(body),
    onError: (error) => {
      setTimeout(() => {
        notify(error, { type: "error" });
      }, 250);
    },
    onSuccess: () => {
      closeModal();
      queryClient.invalidateQueries({
        queryKey: [QueryKey.REFERRAL_USER],
      });
      setTimeout(() => {
        notify("Payment settings were added!", { type: "success" });
      }, 250);
    },
  });

  return {
    setReferralPaymentSettings,
    isSetReferralPaymentSettingsLoading: isPending,
  };
};
